import MatrizUserList from "./components/List";

const MatrizPage = () => {
    return (
        <MatrizUserList />
    )
}

export default MatrizPage;